// 店铺名中可用类目简称对照表数据
export const categoryAliasList = [
  {
    category: "3C数码配件",
    name: "数码"
  },
  {
    category: "DIY电脑",
    name: "DIY电脑"
  },
  {
    category: "办公用品/办公设备/耗材/相关服务",
    name: "办公用品"
  },
  {
    category: "办公用品/办公设备/耗材/相关服务",
    name: "办公设备"
  },
  {
    category: "办公用品/办公设备/耗材/相关服务",
    name: "办公文具"
  },
  {
    category: "办公用品/办公设备/耗材/相关服务",
    name: "投影仪"
  },
  {
    category: "办公用品/办公设备/耗材/相关服务",
    name: "打印机"
  },
  {
    category: "办公用品/办公设备/耗材/相关服务",
    name: "投影幕布"
  },
  {
    category: "模玩/动漫/周边/娃圈/三坑/桌游",
    name: "玩具"
  },
  {
    category: "模玩/动漫/周边/娃圈/三坑/桌游",
    name: "桌游"
  },
  {
    category: "模玩/动漫/周边/娃圈/三坑/桌游",
    name: "二次元"
  },
  {
    category: "模玩/动漫/周边/娃圈/三坑/桌游",
    name: "动漫"
  },
  {
    category: "模玩/动漫/周边/娃圈/三坑/桌游",
    name: "模玩"
  },
  {
    category: "模玩/动漫/周边/娃圈/三坑/桌游",
    name: "潮玩"
  },
  {
    category: "模玩/动漫/周边/娃圈/三坑/桌游",
    name: "卡牌"
  },
  {
    category: "模玩/动漫/周边/娃圈/三坑/桌游",
    name: "周边"
  },
  {
    category: "电子教育",
    name: "电子教育"
  },
  {
    category: "笔记本电脑",
    name: "笔记本电脑"
  },
  {
    category: "电脑组件",
    name: "显示器"
  },
  {
    category: "电脑组件",
    name: "电脑组件"
  },
  {
    category: "电脑组件",
    name: "板卡"
  },
  {
    category: "电脑组件",
    name: "机电"
  },
  {
    category: "电脑外设",
    name: "键鼠"
  },
  {
    category: "电脑外设",
    name: "声卡"
  },
  {
    category: "电脑外设",
    name: "电脑外设"
  },
  {
    category: "电玩/配件/游戏/攻略",
    name: "电玩"
  },
  {
    category: "电子元器件市场",
    name: "数码配件"
  },
  {
    category: "平板电脑/MID",
    name: "智慧办公"
  },
  {
    category: "平板电脑/MID",
    name: "平板电脑"
  },
  {
    category: "品牌台机/品牌一体机/服务器",
    name: "电脑"
  },
  {
    category: "摄影/摄像",
    name: "相机"
  },
  {
    category: "手机",
    name: "手机"
  },
  {
    category: "数码存储设备",
    name: "存储"
  },
  {
    category: "网络设备/网络相关",
    name: "网络"
  },
  {
    category: "大家电",
    name: "大家电"
  },
  {
    category: "大家电",
    name: "冰箱"
  },
  {
    category: "大家电",
    name: "洗衣机"
  },
  {
    category: "大家电",
    name: "空调"
  },
  {
    category: "大家电",
    name: "电视"
  },
  {
    category: "大家电",
    name: "热水器"
  },
  {
    category: "大家电",
    name: "冷柜"
  },
  {
    category: "大家电",
    name: "洗碗机"
  },
  {
    category: "大家电",
    name: "移动空调"
  },
  {
    category: "大家电",
    name: "中央空调"
  },
  {
    category: "大家电",
    name: "集成灶"
  },
  {
    category: "大家电",
    name: "烘干机"
  },
  {
    category: "大家电",
    name: "厨卫"
  },
  {
    category: "影音电器",
    name: "影音娱乐"
  },
  {
    category: "影音电器",
    name: "影音"
  },
  {
    category: "影音电器",
    name: "耳机"
  },
  {
    category: "影音电器",
    name: "音响"
  },
  {
    category: "智能设备",
    name: "智能设备"
  },
  {
    category: "智能设备",
    name: "智能手表"
  },
  {
    category: "智能设备",
    name: "智慧生活"
  },
  {
    category: "智能设备",
    name: "儿童手表"
  },
  {
    category: "智能设备",
    name: "智能飞行"
  },
  {
    category: "智能设备",
    name: "智能摄像"
  },
  {
    category: "智能设备",
    name: "智能健身"
  },
  {
    category: "智能设备",
    name: "智能手环"
  },
  {
    category: "智能设备",
    name: "智能出行"
  },
  {
    category: "智能设备",
    name: "智能机器人"
  },
  {
    category: "智能设备",
    name: "运动健康"
  },
  {
    category: "智能设备",
    name: "VR"
  },
  {
    category: "男装",
    name: "鹅绒"
  },
  {
    category: "男装",
    name: "服饰"
  },
  {
    category: "男装",
    name: "男装"
  },
  {
    category: "男装",
    name: "潮流男装"
  },
  {
    category: "男装",
    name: "品质男装"
  },
  {
    category: "男装",
    name: "休闲男装"
  },
  {
    category: "男装",
    name: "时尚男装"
  },
  {
    category: "男装",
    name: "时尚"
  },
  {
    category: "男装",
    name: "休闲"
  },
  {
    category: "男装",
    name: "商务男装"
  },
  {
    category: "内衣裤袜",
    name: "内衣"
  },
  {
    category: "女装",
    name: "女装"
  },
  {
    category: "女装",
    name: "旗袍"
  },
  {
    category: "女装",
    name: "皮草"
  },
  {
    category: "女装",
    name: "婚纱"
  },
  {
    category: "女装",
    name: "轻奢羽绒服"
  },
  {
    category: "女装",
    name: "羽绒服"
  },
  {
    category: "服饰配件/皮带/帽子/围巾",
    name: "配饰"
  },
  {
    category: "服饰配件/皮带/帽子/围巾",
    name: "服饰配件"
  },
  {
    category: "个人护理",
    name: "女性护理"
  },
  {
    category: "个人护理",
    name: "口腔护理"
  },
  {
    category: "个人护理",
    name: "洗护发"
  },
  {
    category: "个人护理",
    name: "身体护理"
  },
  {
    category: "个人护理",
    name: "个人护理"
  },
  {
    category: "个人护理",
    name: "染发造型"
  },
  {
    category: "个人护理",
    name: "护手护足"
  },
  {
    category: "个人护理",
    name: "身体清洁"
  },
  {
    category: "个人护理",
    name: "个护用具"
  },
  {
    category: "洗护清洁剂/卫生巾/纸/香薰",
    name: "洗护清洁"
  },
  {
    category: "洗护清洁剂/卫生巾/纸/香薰",
    name: "成人纸尿裤"
  },
  {
    category: "洗护清洁剂/卫生巾/纸/香薰",
    name: "织物护理"
  },
  {
    category: "洗护清洁剂/卫生巾/纸/香薰",
    name: "家居清洁"
  },
  {
    category: "洗护清洁剂/卫生巾/纸/香薰",
    name: "香薰用品"
  },
  {
    category: "洗护清洁剂/卫生巾/纸/香薰",
    name: "纸品湿巾"
  },
  {
    category: "洗护清洁剂/卫生巾/纸/香薰",
    name: "衣物清洁"
  },
  {
    category: "洗护清洁剂/卫生巾/纸/香薰",
    name: "洗脸巾"
  },
  {
    category: "洗护清洁剂/卫生巾/纸/香薰",
    name: "家庭环境清洁"
  },
  {
    category: "洗护清洁剂/卫生巾/纸/香薰",
    name: "家私皮具护理"
  },
  {
    category: "洗护清洁剂/卫生巾/纸/香薰",
    name: "空气净化"
  },
  {
    category: "洗护清洁剂/卫生巾/纸/香薰",
    name: "驱虫用品"
  },
  {
    category: "洗护清洁剂/卫生巾/纸/香薰",
    name: "消毒用品"
  },
  {
    category: "节庆用品/文创",
    name: "礼品用品"
  },
  {
    category: "节庆用品/文创",
    name: "文具礼品"
  },
  {
    category: "节庆用品/文创",
    name: "节日用品"
  },
  {
    category: "节庆用品/文创",
    name: "文创用品"
  },
  {
    category: "彩妆/香水/美妆工具",
    name: "化妆品"
  },
  {
    category: "彩妆/香水/美妆工具",
    name: "香水"
  },
  {
    category: "彩妆/香水/美妆工具",
    name: "美妆工具"
  },
  {
    category: "彩妆/香水/美妆工具",
    name: "美妆"
  },
  {
    category: "美容/个护仪器",
    name: "美容仪"
  },
  {
    category: "美容/个护仪器",
    name: "美容工具"
  },
  {
    category: "美容/个护仪器",
    name: "脱毛仪"
  },
  {
    category: "美容护肤",
    name: "护肤"
  },
  {
    category: "美容护肤",
    name: "美容"
  },
  {
    category: "美容护肤",
    name: "男士护肤"
  },
  {
    category: "宠物/宠物食品及用品",
    name: "宠物"
  },
  {
    category: "宠物/宠物食品及用品",
    name: "宠物食品"
  },
  {
    category: "宠物/宠物食品及用品",
    name: "宠物用品"
  },
  {
    category: "宠物/宠物食品及用品",
    name: "水族"
  },
  {
    category: "童装/婴儿装/亲子装",
    name: "童装"
  },
  {
    category: "童装/婴儿装/亲子装",
    name: "儿童服饰"
  },
  {
    category: "童装/婴儿装/亲子装",
    name: "童装童鞋"
  },
  {
    category: "童装/婴儿装/亲子装",
    name: "婴童服饰"
  },
  {
    category: "童装/婴儿装/亲子装",
    name: "儿童内裤"
  },
  {
    category: "童装/婴儿装/亲子装",
    name: "儿童羽绒服"
  },
  {
    category: "童装/婴儿装/亲子装",
    name: "男童"
  },
  {
    category: "童装/婴儿装/亲子装",
    name: "女童"
  },
  {
    category: "童装/婴儿装/亲子装",
    name: "儿童家居服"
  },
  {
    category: "婴童尿裤",
    name: "婴童洗护"
  },
  {
    category: "婴童尿裤",
    name: "婴童尿裤"
  },
  {
    category: "婴童用品",
    name: "婴童寝具"
  },
  {
    category: "婴童用品",
    name: "婴童生活"
  },
  {
    category: "婴童用品",
    name: "婴童用品"
  },
  {
    category: "奶粉/辅食/营养品/零食",
    name: "母婴"
  },
  {
    category: "奶粉/辅食/营养品/零食",
    name: "儿童奶粉"
  },
  {
    category: "奶粉/辅食/营养品/零食",
    name: "辅食"
  },
  {
    category: "奶粉/辅食/营养品/零食",
    name: "婴童营养品"
  },
  {
    category: "奶粉/辅食/营养品/零食",
    name: "婴童调味品"
  },
  {
    category: "奶粉/辅食/营养品/零食",
    name: "婴幼儿奶粉"
  },
  {
    category: "奶粉/辅食/营养品/零食",
    name: "婴童食品"
  },
  {
    category: "奶粉/辅食/营养品/零食",
    name: "婴童零食"
  },
  {
    category: "童鞋/婴儿鞋/亲子鞋",
    name: "童鞋"
  },
  {
    category: "童鞋/婴儿鞋/亲子鞋",
    name: "亲子"
  },
  {
    category: "童鞋/婴儿鞋/亲子鞋",
    name: "儿童"
  },
  {
    category: "生鲜",
    name: "生鲜"
  },
  {
    category: "奢侈品",
    name: "奢侈品"
  },
  {
    category: "保健食品/膳食营养补充食品",
    name: "保健品"
  },
  {
    category: "保健食品/膳食营养补充食品",
    name: "眼部保健"
  },
  {
    category: "保健食品/膳食营养补充食品",
    name: "膳食"
  },
  {
    category: "保健食品/膳食营养补充食品",
    name: "营养膳食"
  },
  {
    category: "保健食品/膳食营养补充食品",
    name: "运动营养"
  },
  {
    category: "保健食品/膳食营养补充食品",
    name: "营养代餐"
  },
  {
    category: "保健食品/膳食营养补充食品",
    name: "益生菌"
  },
  {
    category: "保健食品/膳食营养补充食品",
    name: "胶原蛋白"
  },
  {
    category: "保健食品/膳食营养补充食品",
    name: "基础营养"
  },
  {
    category: "传统滋补营养品",
    name: "保健食品"
  },
  {
    category: "传统滋补营养品",
    name: "滋补养生"
  },
  {
    category: "传统滋补营养品",
    name: "滋补"
  },
  {
    category: "传统滋补营养品",
    name: "营养食品"
  },
  {
    category: "传统滋补营养品",
    name: "燕窝"
  },
  {
    category: "传统滋补营养品",
    name: "枸杞"
  },
  {
    category: "传统滋补营养品",
    name: "阿胶"
  },
  {
    category: "传统滋补营养品",
    name: "蜂蜜"
  },
  {
    category: "传统滋补营养品",
    name: "养生茶"
  },
  {
    category: "传统滋补营养品",
    name: "人参"
  },
  {
    category: "传统滋补营养品",
    name: "花胶"
  },
  {
    category: "传统滋补营养品",
    name: "藏红花"
  },
  {
    category: "传统滋补营养品",
    name: "灵芝"
  },
  {
    category: "传统滋补营养品",
    name: "参茸贵细"
  },
  {
    category: "酒类",
    name: "酒类"
  },
  {
    category: "酒类",
    name: "白酒"
  },
  {
    category: "酒类",
    name: "啤酒"
  },
  {
    category: "酒类",
    name: "葡萄酒"
  },
  {
    category: "酒类",
    name: "黄酒"
  },
  {
    category: "酒类",
    name: "洋酒"
  },
  {
    category: "酒类",
    name: "米酒"
  },
  {
    category: "酒类",
    name: "养生酒"
  },
  {
    category: "酒类",
    name: "预调酒"
  },
  {
    category: "酒类",
    name: "名酒"
  },
  {
    category: "酒类",
    name: "起泡酒"
  },
  {
    category: "酒类",
    name: "威士忌"
  },
  {
    category: "酒类",
    name: "鸡尾酒"
  },
  {
    category: "酒类",
    name: "老酒"
  },
  {
    category: "酒类",
    name: "甜酒"
  },
  {
    category: "酒类",
    name: "白兰地"
  },
  {
    category: "酒类",
    name: "精品酒"
  },
  {
    category: "酒类",
    name: "力娇酒"
  },
  {
    category: "酒类",
    name: "酱香酒"
  },
  {
    category: "酒类",
    name: "果酒"
  },
  {
    category: "茶",
    name: "茶叶"
  },
  {
    category: "茶",
    name: "滇红"
  },
  {
    category: "咖啡/麦片/冲饮",
    name: "乳品"
  },
  {
    category: "咖啡/麦片/冲饮",
    name: "乳制品"
  },
  {
    category: "咖啡/麦片/冲饮",
    name: "饮品"
  },
  {
    category: "咖啡/麦片/冲饮",
    name: "奶粉"
  },
  {
    category: "咖啡/麦片/冲饮",
    name: "成人奶粉"
  },
  {
    category: "咖啡/麦片/冲饮",
    name: "酸奶"
  },
  {
    category: "咖啡/麦片/冲饮",
    name: "奶酪"
  },
  {
    category: "咖啡/麦片/冲饮",
    name: "咖啡"
  },
  {
    category: "咖啡/麦片/冲饮",
    name: "冰淇淋"
  },
  {
    category: "咖啡/麦片/冲饮",
    name: "水饮"
  },
  {
    category: "咖啡/麦片/冲饮",
    name: "牛奶"
  },
  {
    category: "咖啡/麦片/冲饮",
    name: "冲饮"
  },
  {
    category: "粮油米面/南北干货/调味品",
    name: "调味品"
  },
  {
    category: "粮油米面/南北干货/调味品",
    name: "粮油"
  },
  {
    category: "粮油米面/南北干货/调味品",
    name: "干货"
  },
  {
    category: "粮油米面/南北干货/调味品",
    name: "烘焙"
  },
  {
    category: "粮油米面/南北干货/调味品",
    name: "速食"
  },
  {
    category: "粮油米面/南北干货/调味品",
    name: "食用油"
  },
  {
    category: "粮油米面/南北干货/调味品",
    name: "大米"
  },
  {
    category: "粮油米面/南北干货/调味品",
    name: "米面"
  },
  {
    category: "粮油米面/南北干货/调味品",
    name: "杂粮"
  },
  {
    category: "零食/坚果/特产",
    name: "食品"
  },
  {
    category: "零食/坚果/特产",
    name: "坚果"
  },
  {
    category: "零食/坚果/特产",
    name: "膨化食品"
  },
  {
    category: "零食/坚果/特产",
    name: "糕点"
  },
  {
    category: "零食/坚果/特产",
    name: "豆制品"
  },
  {
    category: "零食/坚果/特产",
    name: "糖果"
  },
  {
    category: "零食/坚果/特产",
    name: "巧克力"
  },
  {
    category: "零食/坚果/特产",
    name: "海味"
  },
  {
    category: "零食/坚果/特产",
    name: "蜜饯果干"
  },
  {
    category: "零食/坚果/特产",
    name: "肉类卤味"
  },
  {
    category: "零食/坚果/特产",
    name: "零食"
  },
  {
    category: "零食/坚果/特产",
    name: "面包"
  },
  {
    category: "零食/坚果/特产",
    name: "月饼"
  },
  {
    category: "零食/坚果/特产",
    name: "轻食"
  },
  {
    category: "教育音像",
    name: "音像"
  },
  {
    category: "教育音像",
    name: "图书音像"
  },
  {
    category: "书籍/杂志/报纸",
    name: "图书"
  },
  {
    category: "书籍/杂志/报纸",
    name: "点读书"
  },
  {
    category: "书籍/杂志/报纸",
    name: "进口图书"
  },
  {
    category: "学习用品",
    name: "学习用品"
  },
  {
    category: "学习用品",
    name: "文具"
  },
  {
    category: "教育培训",
    name: "教育"
  },
  {
    category: "教育培训",
    name: "培训"
  },
  {
    category: "教育培训",
    name: "学考"
  },
  {
    category: "教育培训",
    name: "知识服务"
  },
  {
    category: "数字阅读",
    name: "电子书"
  },
  {
    category: "数字阅读",
    name: "有声书"
  },
  {
    category: "乐器/吉他/钢琴/配件",
    name: "乐器"
  },
  {
    category: "玩具/童车/益智/积木/模型",
    name: "母婴玩具"
  },
  {
    category: "玩具/童车/益智/积木/模型",
    name: "童车"
  },
  {
    category: "玩具/童车/益智/积木/模型",
    name: "积木"
  },
  {
    category: "玩具/童车/益智/积木/模型",
    name: "模型"
  },
  {
    category: "男鞋",
    name: "男鞋"
  },
  {
    category: "女鞋",
    name: "女鞋"
  },
  {
    category: "女鞋",
    name: "鞋类"
  },
  {
    category: "箱包",
    name: "箱包"
  },
  {
    category: "箱包",
    name: "女包"
  },
  {
    category: "箱包",
    name: "男包"
  },
  {
    category: "箱包",
    name: "行李箱"
  },
  {
    category: "户外/登山/野营/旅行用品",
    name: "滑雪"
  },
  {
    category: "户外/登山/野营/旅行用品",
    name: "运动户外"
  },
  {
    category: "户外/登山/野营/旅行用品",
    name: "登山"
  },
  {
    category: "户外/登山/野营/旅行用品",
    name: "野营"
  },
  {
    category: "户外/登山/野营/旅行用品",
    name: "旅行用品"
  },
  {
    category: "户外/登山/野营/旅行用品",
    name: "户外"
  },
  {
    category: "运动包/户外包/配件",
    name: "户外包"
  },
  {
    category: "运动包/户外包/配件",
    name: "运动包"
  },
  {
    category: "运动鞋",
    name: "跑步"
  },
  {
    category: "运动鞋",
    name: "男子"
  },
  {
    category: "运动鞋",
    name: "女子"
  },
  {
    category: "运动鞋",
    name: "户外鞋服"
  },
  {
    category: "自行车/骑行装备/零配件",
    name: "运动装备"
  },
  {
    category: "自行车/骑行装备/零配件",
    name: "自行车"
  },
  {
    category: "电动车/配件/交通工具",
    name: "运动配件"
  },
  {
    category: "电动车/配件/交通工具",
    name: "户外配件"
  },
  {
    category: "电动车/配件/交通工具",
    name: "电动车"
  },
  {
    category: "运动/瑜伽/健身/球迷用品",
    name: "运动器械"
  },
  {
    category: "运动/瑜伽/健身/球迷用品",
    name: "运动健身"
  },
  {
    category: "运动/瑜伽/健身/球迷用品",
    name: "健身训练"
  },
  {
    category: "运动/瑜伽/健身/球迷用品",
    name: "篮球"
  },
  {
    category: "运动/瑜伽/健身/球迷用品",
    name: "健身"
  },
  {
    category: "运动/瑜伽/健身/球迷用品",
    name: "球迷用品"
  },
  {
    category: "运动/瑜伽/健身/球迷用品",
    name: "轻运动"
  },
  {
    category: "运动服/休闲服装",
    name: "运动"
  },
  {
    category: "运动服/休闲服装",
    name: "运动鞋服"
  },
  {
    category: "居家日用",
    name: "家居"
  },
  {
    category: "居家日用",
    name: "居家日用"
  },
  {
    category: "居家日用",
    name: "个人防护"
  },
  {
    category: "居家日用",
    name: "婚庆用品"
  },
  {
    category: "居家日用",
    name: "雨具"
  },
  {
    category: "居家日用",
    name: "创意礼品"
  },
  {
    category: "餐饮具",
    name: "餐饮具"
  },
  {
    category: "餐饮具",
    name: "厨房用品"
  },
  {
    category: "餐饮具",
    name: "餐具"
  },
  {
    category: "餐饮具",
    name: "饮具"
  },
  {
    category: "餐饮具",
    name: "水具"
  },
  {
    category: "餐饮具",
    name: "刀具"
  },
  {
    category: "厨房/烹饪用具",
    name: "厨具"
  },
  {
    category: "厨房/烹饪用具",
    name: "烹饪用具"
  },
  {
    category: "厨房/烹饪用具",
    name: "炊具"
  },
  {
    category: "厨房/烹饪用具",
    name: "厨房日用"
  },
  {
    category: "厨房/烹饪用具",
    name: "锅具"
  },
  {
    category: "厨房/烹饪用具",
    name: "中式厨具"
  },
  {
    category: "厨房电器",
    name: "净水"
  },
  {
    category: "厨房电器",
    name: "厨房电器"
  },
  {
    category: "厨房电器",
    name: "饮水"
  },
  {
    category: "厨房电器",
    name: "中式厨电"
  },
  {
    category: "厨房电器",
    name: "西式厨电"
  },
  {
    category: "电子/电工",
    name: "电工"
  },
  {
    category: "电子/电工",
    name: "电气"
  },
  {
    category: "电子/电工",
    name: "智能家装"
  },
  {
    category: "电子/电工",
    name: "集成家居"
  },
  {
    category: "电子/电工",
    name: "家居电气"
  },
  {
    category: "电子/电工",
    name: "电工电气"
  },
  {
    category: "电子/电工",
    name: "电线电缆"
  },
  {
    category: "电子/电工",
    name: "开关插座"
  },
  {
    category: "电子/电工",
    name: "开关"
  },
  {
    category: "电子/电工",
    name: "插座"
  },
  {
    category: "电子/电工",
    name: "安防"
  },
  {
    category: "电子/电工",
    name: "摄像头"
  },
  {
    category: "电子/电工",
    name: "电子电工"
  },
  {
    category: "家居饰品",
    name: "家饰"
  },
  {
    category: "家居饰品",
    name: "香薰"
  },
  {
    category: "家居饰品",
    name: "车载用品"
  },
  {
    category: "家居饰品",
    name: "装饰品"
  },
  {
    category: "家居饰品",
    name: "相框"
  },
  {
    category: "家庭/个人清洁工具",
    name: "个护用品"
  },
  {
    category: "家庭/个人清洁工具",
    name: "清洁用品"
  },
  {
    category: "家庭/个人清洁工具",
    name: "家居生活"
  },
  {
    category: "家庭/个人清洁工具",
    name: "清洁工具"
  },
  {
    category: "家装灯饰光源",
    name: "灯具"
  },
  {
    category: "家装灯饰光源",
    name: "照明"
  },
  {
    category: "家装灯饰光源",
    name: "灯饰"
  },
  {
    category: "家装灯饰光源",
    name: "家装"
  },
  {
    category: "金属材料及制品",
    name: "金属材料"
  },
  {
    category: "基础建材",
    name: "建材"
  },
  {
    category: "基础建材",
    name: "涂料"
  },
  {
    category: "基础建材",
    name: "家用五金"
  },
  {
    category: "基础建材",
    name: "锁具"
  },
  {
    category: "基础建材",
    name: "智能门锁"
  },
  {
    category: "基础建材",
    name: "油漆"
  },
  {
    category: "基础建材",
    name: "防水材料"
  },
  {
    category: "机械设备",
    name: "机械"
  },
  {
    category: "机械设备",
    name: "机械设备"
  },
  {
    category: "居家布艺",
    name: "家居用品"
  },
  {
    category: "摩托车/装备/配件",
    name: "摩托车"
  },
  {
    category: "摩托车/装备/配件",
    name: "摩托车装备"
  },
  {
    category: "摩托车/装备/配件",
    name: "摩托车配件"
  },
  {
    category: "清洗/食品/商业设备",
    name: "清洗设备"
  },
  {
    category: "清洗/食品/商业设备",
    name: "食品设备"
  },
  {
    category: "清洗/食品/商业设备",
    name: "商业设备"
  },
  {
    category: "汽车零配件",
    name: "车载电器"
  },
  {
    category: "汽车零配件",
    name: "汽车工具"
  },
  {
    category: "汽车零配件",
    name: "汽车配件"
  },
  {
    category: "汽车零配件",
    name: "蓄电池"
  },
  {
    category: "汽车零配件",
    name: "汽车零部件"
  },
  {
    category: "汽车零配件",
    name: "轮胎"
  },
  {
    category: "汽车零配件",
    name: "润滑油"
  },
  {
    category: "汽车零配件",
    name: "工业油"
  },
  {
    category: "汽车零配件",
    name: "汽车养护"
  },
  {
    category: "汽车零配件",
    name: "汽车美容"
  },
  {
    category: "汽车零配件",
    name: "车灯"
  },
  {
    category: "汽车零配件",
    name: "汽车维保"
  },
  {
    category: "汽车用品",
    name: "汽车用品"
  },
  {
    category: "汽车用品",
    name: "汽车电子"
  },
  {
    category: "汽车用品",
    name: "汽车清洗"
  },
  {
    category: "汽车用品",
    name: "汽车改装"
  },
  {
    category: "全屋定制",
    name: "木门"
  },
  {
    category: "全屋定制",
    name: "全屋定制"
  },
  {
    category: "全屋定制",
    name: "地板"
  },
  {
    category: "全屋定制",
    name: "楼梯"
  },
  {
    category: "全屋定制",
    name: "采暖"
  },
  {
    category: "全屋定制",
    name: "衣柜"
  },
  {
    category: "全屋定制",
    name: "橱柜"
  },
  {
    category: "全屋定制",
    name: "集成吊顶"
  },
  {
    category: "床上用品",
    name: "家纺"
  },
  {
    category: "床上用品",
    name: "生活"
  },
  {
    category: "床上用品",
    name: "羽绒"
  },
  {
    category: "床上用品",
    name: "枕芯"
  },
  {
    category: "床上用品",
    name: "被芯"
  },
  {
    category: "床上用品",
    name: "婚庆"
  },
  {
    category: "床上用品",
    name: "酒店床品"
  },
  {
    category: "床上用品",
    name: "床上用品"
  },
  {
    category: "床上用品",
    name: "纺织品"
  },
  {
    category: "儿童床品/家纺",
    name: "儿童家纺"
  },
  {
    category: "儿童床品/家纺",
    name: "儿童床品"
  },
  {
    category: "个人保健/护理电器",
    name: "男士理容"
  },
  {
    category: "个人保健/护理电器",
    name: "美容美发"
  },
  {
    category: "个人保健/护理电器",
    name: "健康电器"
  },
  {
    category: "个人保健/护理电器",
    name: "按摩器"
  },
  {
    category: "个人保健/护理电器",
    name: "按摩椅"
  },
  {
    category: "个人保健/护理电器",
    name: "个护保健"
  },
  {
    category: "家装主材",
    name: "家装主材"
  },
  {
    category: "家装主材",
    name: "卫浴用品"
  },
  {
    category: "家装主材",
    name: "厨房"
  },
  {
    category: "家装主材",
    name: "厨卫建材"
  },
  {
    category: "家装主材",
    name: "晾晒"
  },
  {
    category: "家装主材",
    name: "浴霸"
  },
  {
    category: "家装主材",
    name: "浴霸吊顶"
  },
  {
    category: "家装主材",
    name: "环保用品"
  },
  {
    category: "家装主材",
    name: "智能家居"
  },
  {
    category: "家装主材",
    name: "瓷砖"
  },
  {
    category: "家装主材",
    name: "浴室柜"
  },
  {
    category: "家装主材",
    name: "除醛用品"
  },
  {
    category: "家装主材",
    name: "厨卫五金"
  },
  {
    category: "家装主材",
    name: "晾衣机"
  },
  {
    category: "商业/办公家具",
    name: "办公家具"
  },
  {
    category: "商业/办公家具",
    name: "商业家具"
  },
  {
    category: "商业/办公家具",
    name: "医疗家具"
  },
  {
    category: "生活电器",
    name: "电器"
  },
  {
    category: "生活电器",
    name: "小家电"
  },
  {
    category: "生活电器",
    name: "环境电器"
  },
  {
    category: "生活电器",
    name: "清洁电器"
  },
  {
    category: "生活电器",
    name: "吸尘器"
  },
  {
    category: "生活电器",
    name: "扫地机器人"
  },
  {
    category: "生活电器",
    name: "洗地机"
  },
  {
    category: "生活电器",
    name: "生活电器"
  },
  {
    category: "生活电器",
    name: "家用电器"
  },
  {
    category: "生活电器",
    name: "智能电器"
  },
  {
    category: "收纳整理",
    name: "收纳用品"
  },
  {
    category: "收纳整理",
    name: "家居日用"
  },
  {
    category: "五金/工具",
    name: "五金"
  },
  {
    category: "五金/工具",
    name: "工具"
  },
  {
    category: "五金/工具",
    name: "五金工具"
  },
  {
    category: "五金/工具",
    name: "仪器仪表"
  },
  {
    category: "五金/工具",
    name: "劳保用品"
  },
  {
    category: "装修设计/施工/监理",
    name: "装修"
  },
  {
    category: "装修设计/施工/监理",
    name: "设计"
  },
  {
    category: "装修设计/施工/监理",
    name: "施工"
  },
  {
    category: "装修设计/施工/监理",
    name: "监理"
  },
  {
    category: "装修设计/施工/监理",
    name: "装饰"
  },
  {
    category: "住宅家具",
    name: "家具"
  },
  {
    category: "住宅家具",
    name: "床垫"
  },
  {
    category: "住宅家具",
    name: "儿童家具"
  },
  {
    category: "住宅家具",
    name: "学习桌椅"
  },
  {
    category: "住宅家具",
    name: "电脑椅"
  },
  {
    category: "住宅家具",
    name: "户外家具"
  },
  {
    category: "住宅家具",
    name: "智能家具"
  },
  {
    category: "住宅家具",
    name: "实木家具"
  },
  {
    category: "钟表类",
    name: "钟表"
  },
  {
    category: "钟表类",
    name: "手表"
  },
  {
    category: "打火机/瑞士军刀/眼镜",
    name: "打火机"
  },
  {
    category: "打火机/瑞士军刀/眼镜",
    name: "眼镜"
  },
  {
    category: "打火机/瑞士军刀/眼镜",
    name: "烟具"
  },
  {
    category: "时尚饰品",
    name: "饰品"
  },
  {
    category: "特色手工艺",
    name: "手工艺"
  },
  {
    category: "陶瓷/紫砂/建盏/茶周边",
    name: "陶瓷"
  },
  {
    category: "陶瓷/紫砂/建盏/茶周边",
    name: "紫砂"
  },
  {
    category: "陶瓷/紫砂/建盏/茶周边",
    name: "建盏"
  },
  {
    category: "陶瓷/紫砂/建盏/茶周边",
    name: "茶周边"
  },
  {
    category: "翡翠/和田玉/琥珀蜜蜡/其他玉石",
    name: "翡翠"
  },
  {
    category: "翡翠/和田玉/琥珀蜜蜡/其他玉石",
    name: "和田玉"
  },
  {
    category: "翡翠/和田玉/琥珀蜜蜡/其他玉石",
    name: "琥珀蜜蜡"
  },
  {
    category: "翡翠/和田玉/琥珀蜜蜡/其他玉石",
    name: "绿松石"
  },
  {
    category: "翡翠/和田玉/琥珀蜜蜡/其他玉石",
    name: "玉石"
  },
  {
    category: "黄金/彩宝/钻石/珍珠",
    name: "珠宝"
  },
  {
    category: "黄金/彩宝/钻石/珍珠",
    name: "黄金"
  },
  {
    category: "黄金/彩宝/钻石/珍珠",
    name: "钻石"
  },
  {
    category: "黄金/彩宝/钻石/珍珠",
    name: "投资金"
  },
  {
    category: "黄金/彩宝/钻石/珍珠",
    name: "珍珠"
  },
  {
    category: "黄金/彩宝/钻石/珍珠",
    name: "钻戒"
  },
  {
    category: "黄金/彩宝/钻石/珍珠",
    name: "彩色宝石"
  },
  {
    category: "保险",
    name: "保险"
  },
  {
    category: "汽车售后服务",
    name: "汽车服务"
  },
  {
    category: "美容美体医疗器械",
    name: "美瞳"
  },
  {
    category: "美容美体医疗器械",
    name: "隐形眼镜"
  },
  {
    category: "木作/书画/钱币/收藏",
    name: "木作"
  },
  {
    category: "木作/书画/钱币/收藏",
    name: "书画"
  },
  {
    category: "木作/书画/钱币/收藏",
    name: "钱币"
  },
  {
    category: "木作/书画/钱币/收藏",
    name: "收藏"
  },
  {
    category: "木作/书画/钱币/收藏",
    name: "书法"
  },
  {
    category: "木作/书画/钱币/收藏",
    name: "古玩杂项"
  },
  {
    category: "新车",
    name: "新能源汽车"
  },
  {
    category: "新车",
    name: "汽车"
  },
  {
    category: "计生用品",
    name: "计生用品"
  },
  {
    category: "二手车",
    name: "二手车"
  },
  {
    category: "全屋智能",
    name: "全屋智能"
  },
  {
    category: "二手潮品鞋服",
    name: "二手鞋服"
  },
  {
    category: "医疗器械",
    name: "健康监测"
  },
  {
    category: "医疗器械",
    name: "护理护具"
  },
  {
    category: "医疗器械",
    name: "理疗器械"
  },
  {
    category: "医疗器械",
    name: "个人理疗"
  },
  {
    category: "医疗器械",
    name: "保健用品"
  },
  {
    category: "医疗器械",
    name: "家庭护理"
  },
  {
    category: "医疗器械",
    name: "中医保健"
  },
  {
    category: "医疗器械",
    name: "医疗保健"
  },
  {
    category: "医疗器械",
    name: "医疗器械"
  },
  {
    category: "医疗器械",
    name: "医用敷料"
  },
  {
    category: "药品",
    name: "医药"
  },
  {
    category: "假发及配件",
    name: "假发"
  },
  {
    category: "孕妇装/孕产妇用品/营养",
    name: "母婴用品"
  },
  {
    category: "孕妇装/孕产妇用品/营养",
    name: "孕产"
  },
  {
    category: "孕妇装/孕产妇用品/营养",
    name: "孕产用品"
  },
  {
    category: "孕妇装/孕产妇用品/营养",
    name: "孕产服饰"
  },
  {
    category: "孕妇装/孕产妇用品/营养",
    name: "哺乳用品"
  },
  {
    category: "孕妇装/孕产妇用品/营养",
    name: "塑身美体"
  },
  {
    category: "孕妇装/孕产妇用品/营养",
    name: "母婴服饰"
  }
];
